export const APPDOWNLOADMODAL_HEADER = 'Download the Fishbrain app';
export const APPDOWNLOADMODAL_TEXT = 'Scan the QR code to download the Fishbrain app.';
